<div class="full-page-container">
  <div class="container px-0">
    <!--Point Summary Bar-->
    <fgb-points-summary-bar [backButtonLink]="'/rewards/auctions'" [backButtonTitle]="'Rewards'"></fgb-points-summary-bar>

    <div
      class="back-btn bg-glass-dark text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
      [routerLink]="'/rewards/auctions'"
    >
      <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
    </div>
  </div>

  <!-- Auction Details -->
  <fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
</div>
